<ng-container [ngSwitch]="bank">

  <div *ngSwitchCase="'rabobank'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://bankieren.rabobank.nl/omgevingskeuze/selectie">Internet Bankieren</a>.</li>
      <li>
        Kies voor 'Service', vervolgens 'Betaal- en spaarrekening' en daarna voor ’Download transacties / afschrift’.
      </li>
      <li>Kies voor 'Aangepast overzicht rekening(en)'</li>
      <li>
        Selecteer alle spaar-, beheer- en betaalrekeningen die van toepassing zijn op uw bewind.
      </li>
      <li>
        Kies de periode waarover u rekening en verantwoording moet afleggen en vervolgens het bestandsformaat
        'Kommagescheiden CSV'. Klik op 'Bestand downloaden'.
      </li>
    </ol>
    <p>Bij Rabobank kunt u bij 'Overzicht op maat' via het 'Aangepaste overzicht' tot acht jaar terug uw bij- en
      afschrijvingen downloaden.</p>
  </div>


  <div *ngSwitchCase="'ing'">
    <ol>
      <li>Log in bij <a target="_blank" class="link" href="https://mijn.ing.nl/login">Mijn ING</a>.</li>
      <li>Kies voor 'Service' en vervolgens 'Af- en bijschrijvingen downloaden'.</li>
      <li>Selecteer alle spaar-, beheer- en betaalrekeningen die van toepassing zijn op uw bewind.</li>
      <li>Kies de periode waarover u rekening en verantwoording moet afleggen en vervolgens het bestandsformaat CSV.
      </li>
    </ol>
    <p>
      <strong>Let op</strong>: download <span style="text-decoration: underline;">niet</span> het oude 'Kommagescheiden
      CSV' formaat.
    </p>
  </div>


  <div *ngSwitchCase="'abn-amro'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://www.abnamro.nl/portal/mijn-abnamro/authenticatie/inloggen/index.html">Internet Bankieren</a>.</li>
      <li>Kies voor 'zelf regelen' en vervolgens 'Bij-en afschrijvingen downloaden' onder meest gekozen.</li>
      <li>Selecteer alle spaar-, beheer- en betaalrekeningen die van toepassing zijn op uw bewind.</li>
      <li>
        Kies de periode waarover u rekening en verantwoording moet afleggen en vervolgens het bestandsformaat MT940.
      </li>
    </ol>
    <p>
      <strong>Tip</strong>: bij ABN Amro kunt u maar tot 18 maanden terug bij- en afschrijvingen in MT940
      bestandsformaat downloaden. Wilt u verder terug? Neem dan contact met ons op door te mailen naar <a target="_blank" class="link" href="mailto:info@reveon.nl?subject=Reveon%20|%2018%20Maanden%20Termijn%20ABN%20Amro">info@reveon.nl</a>.
    </p>
  </div>


  <div *ngSwitchCase="'asn-bank'">
    <ol>
      <li>Log in bij <a target="_blank" class="link" href="https://www.asnbank.nl/online/web/onlinebankieren/inloggen/#/inloggen">ASN Online Bankieren</a>.</li>
      <li>Selecteer de gewenste periode in het overzicht van uw betaalrekening en klik op 'Zoeken'.</li>
      <li>Klik op 'Selectie Downloaden' om de bij- en afschrijvingen in CSV bestandsformaat te downloaden.</li>
    </ol>
  </div>


  <div *ngSwitchCase="'sns'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://www.snsbank.nl/online/web/mijnsns/inloggen/#/">Mijn SNS</a>.</li>
      <li>Selecteer de rekening en periode waarover u transacties wilt downloaden</li>
      <li>Selecteer bij bestandsformaat voor 'MT940' en klik op start downloaden.</li>
    </ol>
    <p>Bij SNS Bank kunt u tot 24 maanden terug bij- en afschriften downloaden.</p>
  </div>


  <div *ngSwitchCase="'bunq'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://bunq.app/login/">Internet Bankieren</a>.</li>
      <li>Selecteer de juiste rekening en druk vervolgens op 'Instellingen'.</li>
      <li>Selecteer de periode waarover u wilt downloaden, kies als bestandsformaat 'CSV' en klik ten slotte op
        downloaden.
      </li>
    </ol>
  </div>


  <div *ngSwitchCase="'regiobank'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://www.regiobank.nl/online/web/mijnregiobank/inloggen/#/inloggen">Mijn RegioBank</a>.</li>
      <li>Kies in het linkermenu bij het onderdeel 'Betalen, Sparen of Beleggen' voor 'Rekeningafschrift'.</li>
      <li>Kies de rekening en de periode waarvan je het afschrift wilt downloaden en kies bij bestandsformaat voor
        'CSV'.
      </li>
    </ol>
    <p>Bij RegioBank kunt u tot 24 maanden terug bij- en afschriften downloaden.</p>
  </div>


  <div *ngSwitchCase="'knab'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://persoonlijk.knab.nl/inloggen">Internet Bankieren</a>.</li>
      <li>Selecteer de gewenste betaalrekening en vervolgens op afschriften.</li>
      <li>Selecteer de gewenste periode, kies bij bestandsformaat voor 'CSV' en klik op start downloaden.</li>
    </ol>
  </div>


  <div *ngSwitchCase="'van-lanschot'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://login.vanlanschot.com/login">Mijn Van Lanschot</a>.</li>
      <li>Klik op 'Documenten' en vervolgens op 'Rekeningafschrift'.</li>
      <li>Kies voor 'CSV' als bestandsformaat, vervolgens 'Exporteren mutaties' en klik ten slotte op downloaden.</li>
    </ol>
  </div>


  <div *ngSwitchCase="'triodos'">
    <ol>
      <li>Log in op <a target="_blank" class="link" href="https://bankieren.triodos.nl/ib-seam/login.seam?locale=nl_NL">Internet Bankieren</a>.</li>
      <li>Klik links in het menu op 'Zelf regelen' en vervolgens rechts in het menu onder 'Downloads' op
        'Rekeningafschriften'.
      </li>
      <li>Selecteer de rekening en de periode waarvan u afschriften wilt downloaden.</li>
      <li>Kies bij bestandsformaat voor 'MT940' en klik op start downloaden.</li>
    </ol>
  </div>


  <div *ngSwitchCase="'andere-bank'">
    <p>
      Download uw bij- en afschrijvingen als CSV of MT940 bestand voor alle rekeningen die van toepassing zijn op het
      bewind. Voor een uitleg hoe dat moet verwijzen wij u graag door naar uw bank.
    </p>
    <div class="spacer-small"></div>
    <p>
      <strong>Let op</strong>: Wanneer u het CSV bestand upload controleren wij of de bank door ons wordt ondersteund. Indien dat nog
      niet het geval is streven wij ernaar om binnen 5 werkdagen deze te ondersteunen.
    </p>
  </div>


</ng-container>
